const _navSections = {
  BUILD:        'build',
  CUSTOMISE:    'customise',
  DESIGN:       'design',
  ENTRIES:      'entries',
  INSIGHTS:     'insights',
  INTEGRATIONS: 'integrations',
  PUBLISHING:   'publishing',
  REWARDS:      'rewards',
  SETTINGS:     'settings',
  PROMOTIONS:   'promotions',
};

_navSections.ALL = _.values(_navSections);
export default _navSections;
